import {
    Component,
    OnInit
} from '@angular/core';
import {
    IUser,
    User
} from '../model/user';
import { LocalStorageService } from 'angular-2-local-storage';
@Component({
    selector: 'frontpage-component',
    template: require('./frontpage.component.html'),
    styles: [require('./frontpage.component.css')]
})

export class FrontpageComponent implements OnInit{

    public loginOpen = false;
    private clicks = 0;
    private lastClick = (new Date()).getTime();

    public username : string;
    public password: string;
    public user : IUser;

    constructor (
        private UserResource : User,
        private localStorageService: LocalStorageService
    ) {}

    public ngOnInit() {
        this.user = this.localStorageService.get('user') as IUser;
        console.log(document.getElementById('home'));
        document.getElementById('home').addEventListener('click', this.homeClick);
    }

    public homeClick = () => {
        console.log(this.clicks);
        let time = (new Date()).getTime();
        if (time - this.lastClick < 500) {
            if (++ this.clicks > 6) {
                this.loginOpen = true;
            }
        } else {
            this.clicks = 1;
        }

        this.lastClick = time;
    };

    public login() {
        /*
        this.UserResource.login({username: this.username, password : this.password})
            .$observable
            .subscribe((user: IUser) => {
                this.user = user;
                this.localStorageService.set('user', user);
                document.location.href = '/reservation';
            });*/
        this.UserResource.current()
            .$observable
            .subscribe((user: IUser) => {
                this.user = user;
                this.localStorageService.set('user', {id: user.id, name: user.name});
                document.location.href = '/reservation';
            });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/frontpage/frontpage.component.ts